import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';


import multi1 from './pictures/multi1.jpg';
import multi2 from './pictures/multi2.jpg';
import multi3 from './pictures/multi3.png';
import multi4 from './pictures/multi4.png';
import multi5 from './pictures/multi5.png';
import multi6 from './pictures/multi6.png';
import multi7 from './pictures/multi7.png';
import multi8 from './pictures/multi8.png';

const Multicultural = () => {
  const images = [multi1, multi2, multi3, multi4, multi5, multi6, multi7, multi8];
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Multicultural Night with MiT Recap</h2>
                    <p class="site-post-meta">May 9th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    Last Friday, we hosted a Multicultural Night with Minorities in Tech (MiT)!
                    We played games from South Korea (Yut Nori and Gong Gi) and western India (Mendikot).
                    We also ate food from different cultures such as Tteok, mochi, banana chips, 
                    seaweed, mango pudding, and ube cakes!
                    </p>
                    <div className="slideshow">
                    <img src={images[currentIndex]} alt="" />
                    <div className="button-container">
                    <div className="button-box" onClick={prevSlide}>Previous</div>
                    <div className="button-box" onClick={nextSlide}>Next</div>
                    </div>
                </div>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Multicultural;
